/**
 * Wat zoeken na een opslag weet (punt l, GO Frank 22 oktober 2026). De backend
 * indexeert het opgeslagen document meteen opnieuw en zegt in `index.status` hoe
 * dat afliep (`services/folder_sync.py`, `herindexeer_een`); deze module maakt er
 * de zin van.
 *
 * PUUR: `t` komt van de aanroeper.
 */

/** De zin onder "Opgeslagen in ...", of de oude zin als de backend niets meldt. */
export function herindexTekst(index, t) {
  const status = index?.status;
  if (status === "klaar") {
    return t("Zoeken kent de nieuwe tekst al: het document is meteen opnieuw ingelezen.");
  }
  if (status === "ongewijzigd") {
    return t("Zoeken kende deze tekst al; er was niets opnieuw in te lezen.");
  }
  if (status === "later") {
    return t("Deze kennisbank wordt nu ingelezen. Zoeken neemt de nieuwe tekst mee in de volgende ronde, binnen een kwartier.");
  }
  if (status === "uitgezet") {
    return t("Inlezen staat uit voor deze kennisbank, dus zoeken gebruikt nog de oudere versie.");
  }
  if (status === "mislukt") {
    return t("Opnieuw inlezen lukte niet ({reden}). Het bestand is wel opgeslagen; de volgende ronde probeert het opnieuw, binnen een kwartier.", { reden: index.reden || "?" });
  }
  // Een backend van voor punt l stuurt geen `index`: dan geldt de oude werkwijze.
  return t("Zoeken gebruikt nog de oudere geindexeerde versie tot de map opnieuw is ingelezen.");
}

/** Of de geindexeerde tekst nu al uit het opgeslagen bestand is opgebouwd. */
export function alIngelezen(index) {
  return index?.status === "klaar" || index?.status === "ongewijzigd";
}
